import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from '../actions';
import { mergeMap, catchError, switchMap, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AuthorService } from 'app/services';
import { AuthorProfile } from 'app/models';
import { MAP_URL } from 'app/pages/topics/constants';

@Injectable()
export class AuthorProfileEffects {
  constructor(
    private actions$: Actions,
    private authorService: AuthorService
  ) {}

  loadPosts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadAuthorProfile),
      mergeMap(({ authorId }) =>
        this.getAuthorContactDetails$(authorId).pipe(
          // tap((response) => console.log(response)),
          switchMap((response) => [
            actions.loadAuthorProfileSuccess({
              authorContactProfile: new AuthorProfile({
                id: response.id,
                name: response.name,
                description: response.description,
                emailAddress: response.emailAddress,
                contactUrl: response.contactUrl,
                twitter: response.twitter,
                linkedIn: response.linkedIn,
                imageUrl: response.imageUrl,
                location: response.location,
                myCompanyStats: response.myCompanyStats,
              }),
            }),
          ]),
          catchError((err) =>
            of(actions.loadAuthorProfileError({ payload: err }))
          )
        )
      )
    )
  );

  getAuthorContactDetails$(id): Observable<any> {
    return this.authorService.getAuthorById(id);
  }
}
